import React from "react";
import { useDispatch } from "react-redux";
//import { Link } from "react-router-dom";
import { Box, Grid, Link } from "@mui/material";
import { useFormik } from "formik";
import moment from "moment";
import { searchData, searchDataWithGet } from "src/app-redux/common-actions";
import { getOrderStatusAction } from "src/app-redux/work-order/actions/workorderActions";
import { IInvoicesItem } from "src/common/typings/invoices";
import {
  getLocalDateTime,
  getUTCDateTimeWithEndOfDay,
  getUTCDateTimeWithStartOfDay,
} from "src/common/utils/app.util";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import { moneyformatter } from "src/common/utils/helpers";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextField from "src/components/CommonTextField/CommonTextField";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";
import { Sticky } from "./stickyinfo";

export default function InvoicesList() {
  const dispatch = useDispatch();
  const { winHeight } = useMyWinHeightContext();
  const [loader, setLoader] = React.useState(false);
  const [gData, setGData] = React.useState<IInvoicesItem[]>([]);
  const [relateInvoiceData, setRelateInvoiceData] = React.useState<any[]>([]);
  const [vendorInvoiceStatuses, setVendorInvoiceStatuses] = React.useState<any[]>([]);
  const [drawerStatus, setdrawerStatus] = React.useState<boolean>(false);
  const [selectedData, setSelectedData] = React.useState<any>({});
  const columns = [
    {
      field: "invoiceNum",
      headerName: "Invoice #",
      type: "string",
      width: 180,
      renderCell: function customCell1(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              isDrawerOpen(params.row);
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "invoiceStatus",
      headerName: "Invoice Status",
      type: "string",
      width: 150,
    },
    {
      field: "checkNo",
      headerName: "Check #",
      type: "string",
      width: 150,
    },
    {
      field: "recievedDate",
      headerName: "Received Date",
      width: 150,
      type: "date",
      valueGetter: (params: any) => {
        if (!params.value) return null;
        const date = moment(params.value, "MM/DD/YYYY").toDate();
        return isNaN(date.getTime()) ? null : date;
      },
    },
    {
      field: "invoiceAmt",
      headerName: "Invoice Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "releaseDate",
      headerName: "Release Date",
      width: 170,
      type: "date",
      valueGetter: (params: any) => {
        if (!params.value) return null;
        const date = moment(params.value, "MM/DD/YYYY").toDate();
        return isNaN(date.getTime()) ? null : date;
      },
    },
    // {
    //   field: "expectedDate",
    //   headerName: "Expected Date",
    //   type: "string",
    //   width: 150,
    //   isDateField: true,
    // },
    {
      field: "payAmt",
      headerName: "Approved Amt", //changed payAmt to Approved Amt => client feebback 450
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "netPay",
      headerName: "Net Pay",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "expectedDate",
      headerName: "Expected Date",
      width: 170,
      type: "date",
      valueGetter: (params: any) => {
        if (!params.value) return null;
        const date = moment(params.value, "MM/DD/YYYY").toDate();
        return isNaN(date.getTime()) ? null : date;
      },
    },
  ];
  React.useEffect(() => {
    dispatch(getOrderStatusAction());
    getVendorInvoiceStatases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVendorInvoiceStatases = async () => {
    setVendorInvoiceStatuses([]);
    setLoader(true);
    try {
      const results: any = await dispatch(searchDataWithGet("/get-vendor-invoice-statuses/"));
      if (results?.allStatusVendorInvoices) {
        const transformedData = results.allStatusVendorInvoices.map((invoice: any) => {
          return {
            ...invoice,
            releaseDate: getLocalDateTime(invoice.releaseDate, "MM/DD/YYYY"),
            recievedDate: getLocalDateTime(invoice.recievedDate, "MM/DD/YYYY"),
          };
        });
        // const updatedStatuses: any[] = [];
        // statusList.map((item) => {
        //   const found = transformedData.find((obj) => obj.code === item.code);
        //   if (found) {
        //     updatedStatuses.push(found);
        //   }
        // });
        setVendorInvoiceStatuses(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };

  const formik = useFormik({
    initialValues: {
      status: "All",
      invoiceNum: "",
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { values, setValues } = formik;

  const handleSearch = async () => {
    const { status, startDate, endDate, invoiceNum } = values;
    const body = {
      status: status || "",
      startDate: startDate ? getUTCDateTimeWithStartOfDay(startDate) : null,
      endDate: endDate ? getUTCDateTimeWithEndOfDay(endDate) : null,
      invoiceNum: invoiceNum || "",
    };
    setGData([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-vendor-invoice-head-inovices", JSON.stringify(body))
      );
      if (results?.vendorInvoices) {
        //const transformedData = results.vendorInvoices as IInvoicesItem[];
        const transformedData = results.vendorInvoices.map((invoice: any) => {
          return { ...invoice, payAmt: invoice.checkNo ? invoice.payAmt : "" };
        });
        setGData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };
  const getInvoiceRelatedOrders = async (id: number) => {
    setRelateInvoiceData([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchDataWithGet(`/get-vendor-inv-detail-by-inv_seq/${id}`)
      );
      if (results?.invoiceDetails) {
        const transformedData = results.invoiceDetails as any[];
        setRelateInvoiceData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };

  const isDrawerOpen = (parms: any) => {
    getInvoiceRelatedOrders(parms.id);
    setSelectedData(parms);
    setdrawerStatus(true);
  };
  let gridMaxHeight = 0;
  const dppr = 1000;
  gridMaxHeight = winHeight - 237;
  return (
    <>
      <CommonDrawer
        heading={"Invoice"}
        isOpen={drawerStatus}
        closeDrawer={() => {
          setdrawerStatus(false);
        }}
        drawerWidth={650}
      >
        <>
          <Sticky stickyInfo={selectedData} relateInvoiceData={relateInvoiceData} />
        </>
      </CommonDrawer>
      <CommonDataGridPage
        module={"Invoices"}
        heading={"List Of Invoices"}
        pageTitle="TFG | Portal | Invoices"
        GridDataComp={
          <CommonXGrid
            defaultPerPageRecord={dppr}
            height={gridMaxHeight}
            rows={gData}
            columns={columns}
            loader={loader}
            modifyColumns
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={2}>
              <CommonTextFieldDate
                label={"Start Date"}
                type={"date"}
                name={"startDate"}
                value={formik.values.startDate}
                onChange={formik.handleChange}
                maxDate={formik.values.endDate}
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextFieldDate
                label={"End Date"}
                type={"date"}
                name={"endDate"}
                value={formik.values.endDate}
                onChange={formik.handleChange}
                minDate={formik.values.startDate}
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonAutoCompleteField
                label="Status"
                name="status"
                optionsType={vendorInvoiceStatuses}
                getOptionLabel={(option: any) => option.webstatus || ""}
                value={
                  vendorInvoiceStatuses.find((ty: any) => ty.code === formik.values?.status) || null
                }
                onChange={(option: any) =>
                  formik.setValues({ ...formik.values, status: option?.code || "" })
                }
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                label="invoice #"
                onChange={formik.handleChange}
                name="invoiceNum"
                value={formik.values.invoiceNum}
              />
            </Grid>
            <Grid item xs={12} md={4} direction="row">
              <Box textAlign="right" mt={0} mb={1}>
                <CommonButton onClick={() => setValues(formik.initialValues)}>Reset</CommonButton>
                <CommonButton isGreen onClick={handleSearch}>
                  Search
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
    </>
  );
}
